/* AnnaluciaDesign Cashmere V10 – toegankelijke fotozoom, galerij en menukleur. */
(() => {
  if (customElements.get('al-cashmere-gallery')) return;

  function syncNavigationColour() {
    const nav = document.querySelector('.header__primary-nav-item [data-title], .header__primary-nav a, .header__primary-nav summary');
    if (nav) {
      const colour = window.getComputedStyle(nav).color;
      if (colour) document.documentElement.style.setProperty('--al-cashmere-nav-color', colour);
    }
  }

  class AlCashmereGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.al-cashmere-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-cg-select]'));
      this.index = Math.max(0, this.slides.findIndex(el => !el.hidden));
      this.onShopifySelect = e => {
        const id = e.detail?.blockId;
        if (!id) return;
        const slideIndex = this.slides.findIndex(el => el.dataset.alBlockId === id);
        if (slideIndex >= 0) this.show(slideIndex);
      };
      document.addEventListener('shopify:block:select', this.onShopifySelect);
      this.querySelectorAll('[data-cg-previous]').forEach(el => el.addEventListener('click', () => this.show(this.index - 1)));
      this.querySelectorAll('[data-cg-next]').forEach(el => el.addEventListener('click', () => this.show(this.index + 1)));
      this.thumbs.forEach(el => el.addEventListener('click', () => this.show(Number(el.dataset.cgSelect) - 1)));
      this.addEventListener('keydown', e => {
        if (this.zoomDialog?.open) return;
        if (e.target.closest('video, iframe, button') && !e.target.matches('[data-cg-select], [data-cg-previous], [data-cg-next]')) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); this.show(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.show(this.index - 1); }
      });
      let touchStartX = 0;
      this.querySelector('.al-cashmere-gallery__main')?.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0]?.screenX ?? 0;
      }, {passive:true});
      this.querySelector('.al-cashmere-gallery__main')?.addEventListener('touchend', e => {
        if (e.target.closest('video, iframe, [data-cg-zoom-src]')) return;
        const distance = (e.changedTouches[0]?.screenX ?? touchStartX) - touchStartX;
        if (Math.abs(distance) > 45) this.show(this.index + (distance < 0 ? 1 : -1));
      }, {passive:true});
      this.initZoom();
      syncNavigationColour();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onShopifySelect);
      if (this.onZoomResize) window.removeEventListener('resize', this.onZoomResize);
    }

    show(index) {
      if (!this.slides?.length) return;
      index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        if (i !== index) {
          slide.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); });
          slide.querySelectorAll('iframe').forEach(frame => {
            const src = frame.getAttribute('src'); if (src) frame.setAttribute('src', src);
          });
        }
        slide.hidden = (i !== index);
      });
      this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
      this.index = index;
      const thumb = this.thumbs[index];
      const rail = thumb?.parentElement;
      const isVertical = this.dataset.thumbPosition === 'left' && window.matchMedia('(min-width: 1000px)').matches;
      if (thumb && rail && isVertical && (thumb.offsetTop < rail.scrollTop || thumb.offsetTop + thumb.offsetHeight > rail.scrollTop + rail.clientHeight)) {
        rail.scrollTo({top: Math.max(0, thumb.offsetTop - rail.offsetTop - rail.clientHeight / 2 + thumb.offsetHeight / 2), behavior:'smooth'});
      } else if (thumb && rail && !isVertical && (thumb.offsetLeft < rail.scrollLeft || thumb.offsetLeft + thumb.offsetWidth > rail.scrollLeft + rail.clientWidth)) {
        rail.scrollTo({left: Math.max(0, thumb.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + thumb.offsetWidth / 2), behavior:'smooth'});
      }
    }

    initZoom() {
      this.zoomDialog = this.querySelector('[data-cg-zoom-dialog]');
      if (!this.zoomDialog) return;
      this.zoomImage = this.zoomDialog.querySelector('[data-cg-zoom-image]');
      this.zoomViewport = this.zoomDialog.querySelector('[data-cg-zoom-viewport]');
      this.zoomableSlides = this.slides.filter(slide => slide.querySelector('[data-cg-zoom-src]'));
      this.slides.forEach((slide, slideIndex) => {
        const trigger = slide.querySelector('[data-cg-zoom-src]');
        if (trigger) trigger.addEventListener('click', () => this.openZoom(slideIndex));
      });
      this.zoomDialog.querySelector('[data-cg-zoom-close]')?.addEventListener('click', () => this.zoomDialog.close());
      this.zoomDialog.querySelector('[data-cg-zoom-prev]')?.addEventListener('click', () => this.navigateZoom(-1));
      this.zoomDialog.querySelector('[data-cg-zoom-next]')?.addEventListener('click', () => this.navigateZoom(1));
      this.zoomDialog.querySelector('[data-cg-zoom-in]')?.addEventListener('click', () => this.setZoom(this.zoomScale + .25));
      this.zoomDialog.querySelector('[data-cg-zoom-out]')?.addEventListener('click', () => this.setZoom(this.zoomScale - .25));
      this.zoomDialog.querySelector('[data-cg-zoom-reset]')?.addEventListener('click', () => this.setZoom(1));
      this.zoomImage?.addEventListener('click', () => {
        if (this.didDragZoom) { this.didDragZoom = false; return; }
        this.setZoom(this.zoomScale > 1 ? 1 : 1.5);
      });
      this.zoomDialog.addEventListener('click', e => {
        if (e.target === this.zoomDialog) this.zoomDialog.close();
      });
      this.zoomDialog.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.navigateZoom(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.navigateZoom(-1); }
        if (e.key === '+' || e.key === '=') { e.preventDefault(); this.setZoom(this.zoomScale + .25); }
        if (e.key === '-') { e.preventDefault(); this.setZoom(this.zoomScale - .25); }
        if (e.key === '0') { e.preventDefault(); this.setZoom(1); }
      });
      this.zoomDialog.addEventListener('close', () => {
        this.zoomImage.removeAttribute('src');
        this.setZoom(1);
      });
      this.zoomScale = 1;
      this.zoomOffset = {x: 0, y: 0};
      this.zoomViewport?.addEventListener('wheel', e => {
        if (!e.ctrlKey && !e.metaKey) return;
        e.preventDefault();
        this.setZoom(this.zoomScale + (e.deltaY < 0 ? .25 : -.25));
      }, {passive:false});
      this.onZoomResize = () => {
        if (this.zoomDialog?.open) this.renderZoom();
      };
      window.addEventListener('resize', this.onZoomResize);
      this.zoomViewport?.addEventListener('pointerdown', e => {
        if (this.zoomScale <= 1 || e.button !== 0 || e.target !== this.zoomImage) return;
        this.zoomPointer = {id:e.pointerId, x:e.clientX, y:e.clientY, offsetX:this.zoomOffset.x, offsetY:this.zoomOffset.y};
        this.didDragZoom = false;
        this.zoomViewport.setPointerCapture(e.pointerId);
      });
      this.zoomViewport?.addEventListener('pointermove', e => {
        if (!this.zoomPointer || e.pointerId !== this.zoomPointer.id) return;
        const dx = e.clientX - this.zoomPointer.x;
        const dy = e.clientY - this.zoomPointer.y;
        if (Math.abs(dx) + Math.abs(dy) > 4) this.didDragZoom = true;
        this.zoomOffset = {x:this.zoomPointer.offsetX + dx, y:this.zoomPointer.offsetY + dy};
        this.renderZoom();
        this.zoomViewport.classList.add('is-dragging');
      });
      ['pointerup','pointercancel','lostpointercapture'].forEach(eventName => {
        this.zoomViewport?.addEventListener(eventName, () => {
          this.zoomPointer = null;
          this.zoomViewport.classList.remove('is-dragging');
        });
      });
    }

    openZoom(index) {
      if (!this.zoomDialog || !this.slides[index]?.querySelector('[data-cg-zoom-src]')) return;
      this.zoomIndex = index;
      this.show(index);
      if (!this.zoomDialog.open) {
        try { this.zoomDialog.showModal(); }
        catch (error) { this.zoomDialog.setAttribute('open', ''); }
      }
      this.displayZoomImage();
    }

    displayZoomImage() {
      const trigger = this.slides[this.zoomIndex]?.querySelector('[data-cg-zoom-src]');
      if (!trigger) return;
      this.setZoom(1);
      this.zoomImage.src = trigger.dataset.cgZoomSrc;
      this.zoomImage.alt = trigger.dataset.cgZoomAlt || '';
      const idx = this.zoomableSlides.indexOf(this.slides[this.zoomIndex]);
      const total = this.zoomableSlides.length;
      const counter = this.zoomDialog.querySelector('[data-cg-zoom-counter]');
      if (counter) counter.textContent = `${idx + 1} / ${total}`;
      ['prev','next'].forEach(direction => {
        const button = this.zoomDialog.querySelector(`[data-cg-zoom-${direction}]`);
        if (button) button.hidden = total <= 1;
      });
    }

    navigateZoom(direction) {
      if (!this.zoomableSlides?.length) return;
      const at = this.zoomableSlides.indexOf(this.slides[this.zoomIndex]);
      const newSlide = this.zoomableSlides[(at + direction + this.zoomableSlides.length) % this.zoomableSlides.length];
      this.zoomIndex = this.slides.indexOf(newSlide);
      this.show(this.zoomIndex);
      this.displayZoomImage();
    }

    setZoom(value) {
      this.zoomScale = Math.max(.5, Math.min(2.5, Math.round(value * 100) / 100));
      this.zoomOffset = {x:0, y:0};
      this.renderZoom();
      const plus = this.zoomDialog?.querySelector('[data-cg-zoom-in]');
      const minus = this.zoomDialog?.querySelector('[data-cg-zoom-out]');
      if (plus) plus.disabled = this.zoomScale >= 2.5;
      if (minus) minus.disabled = this.zoomScale <= .5;
      const level = this.zoomDialog?.querySelector('[data-cg-zoom-level]');
      if (level) level.textContent = `${Math.round(this.zoomScale * 100)}%`;
    }

    renderZoom() {
      if (!this.zoomImage) return;
      const limitX = Math.max(0, (this.zoomImage.offsetWidth * this.zoomScale - this.zoomViewport.clientWidth) / 2);
      const limitY = Math.max(0, (this.zoomImage.offsetHeight * this.zoomScale - this.zoomViewport.clientHeight) / 2);
      this.zoomOffset.x = Math.max(-limitX, Math.min(limitX, this.zoomOffset.x));
      this.zoomOffset.y = Math.max(-limitY, Math.min(limitY, this.zoomOffset.y));
      this.zoomImage.style.transform = `translate(${this.zoomOffset.x}px, ${this.zoomOffset.y}px) scale(${this.zoomScale})`;
      this.zoomViewport.classList.toggle('is-zoomed', this.zoomScale > 1);
    }
  }

  customElements.define('al-cashmere-gallery', AlCashmereGallery);
  document.addEventListener('shopify:section:load', syncNavigationColour);
})();
